import { render } from "./Separator.vue?vue&type=template&id=35e18de9&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"

import "./Separator.vue?vue&type=style&index=0&id=35e18de9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35e18de9"

export default script